import { render, staticRenderFns } from "./ProductWithVariationsCmp.vue?vue&type=template&id=0bed2922&scoped=true&"
import script from "./ProductWithVariationsCmp.vue?vue&type=script&lang=js&"
export * from "./ProductWithVariationsCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductWithVariationsCmp.vue?vue&type=style&index=0&id=0bed2922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bed2922",
  null
  
)

export default component.exports